import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MapPin, Phone, Mail } from "lucide-react";
import { ASSOC } from "@/lib/data";

export default function Footer() {
  return (
    <footer className="bg-[var(--he-bg-dark)] text-white mt-24 he-grain">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img src="/logos/heelevents.png" alt="Heel'Events" className="h-10 w-auto bg-white/85 backdrop-blur-md rounded-full px-4 py-2 shadow-[0_6px_24px_rgba(0,0,0,0.45)] ring-1 ring-white/40" />
          <p className="mt-3 max-w-md text-neutral-400 font-body">
            {ASSOC.slogan}
          </p>
          <p className="mt-6 text-xs text-neutral-500 he-overline">Depuis {ASSOC.since} · Val-de-Marne</p>
        </div>

        <div>
          <h4 className="he-overline text-neutral-400 mb-4">Naviguer</h4>
          <ul className="space-y-2 text-sm font-body">
            <li><Link to="/association" className="hover:text-[var(--he-red)]">L’association</Link></li>
            <li><Link to="/cours" className="hover:text-[var(--he-red)]">Cours</Link></li>
            <li><Link to="/planning" className="hover:text-[var(--he-red)]">Planning</Link></li>
            <li><Link to="/tarifs" className="hover:text-[var(--he-red)]">Tarifs</Link></li>
            <li><Link to="/equipe" className="hover:text-[var(--he-red)]">Équipe</Link></li>
            <li><Link to="/evenements" className="hover:text-[var(--he-red)]">Événements</Link></li>
            <li><Link to="/galerie" className="hover:text-[var(--he-red)]">Galerie</Link></li>
            <li><Link to="/lieux" className="hover:text-[var(--he-red)]">Lieux</Link></li>
            <li><Link to="/contact" className="hover:text-[var(--he-red)]">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="he-overline text-neutral-400 mb-4">Contact</h4>
          <ul className="space-y-2 text-sm font-body">
            <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-[var(--he-red)]" /> {ASSOC.address}</li>
            <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[var(--he-red)]" /> <a href={`tel:${ASSOC.phone.replace(/\s/g,'')}`} className="hover:text-[var(--he-red)]">{ASSOC.phone}</a></li>
            {ASSOC.emails.map((e) => (
              <li key={e} className="flex items-center gap-2"><Mail className="w-4 h-4 text-[var(--he-red)]" /> <a href={`mailto:${e}`} className="hover:text-[var(--he-red)]">{e}</a></li>
            ))}
            <li className="flex items-center gap-2"><Instagram className="w-4 h-4 text-[var(--he-red)]" /> <a href={ASSOC.instagramUrl} target="_blank" rel="noreferrer" className="hover:text-[var(--he-red)]">{ASSOC.instagram}</a></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-neutral-500 font-body">
          <p>© {new Date().getFullYear()} Heel’Events. Tous droits réservés.</p>
          <p className="flex gap-4">
            <Link to="/mentions-legales" className="hover:text-white">Mentions légales</Link>
            <Link to="/confidentialite" className="hover:text-white">Politique de confidentialité</Link>
            <Link to="/admin" data-testid="footer-admin-link" className="hover:text-white">Espace admin</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}
